module.exports = __webpack_public_path__ + "img/product1_2.861b93a1.png";